import { render } from "./MyInstallationRequisitions.vue?vue&type=template&id=5387518a&scoped=true"
import script from "./MyInstallationRequisitions.vue?vue&type=script&lang=js"
export * from "./MyInstallationRequisitions.vue?vue&type=script&lang=js"

import "./MyInstallationRequisitions.vue?vue&type=style&index=0&id=5387518a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5387518a"]])

export default __exports__